// SPDX-FileCopyrightText: 2019-2022 Pleroma Authors <https://pleroma.social>
// SPDX-License-Identifier: AGPL-3.0-only

export const tabs = [
  { label: 'ActivityPub', path: 'activity-pub', tab: ':activity_pub' },
  { label: 'Authentication', path: 'authentication', tab: ':authentication' },
  { label: 'Captcha', path: 'captcha', tab: ':captcha' },
  { label: 'BBS / SSH access', path: 'esshd', tab: ':esshd' },
  { label: 'Emoji', path: 'emoji', tab: ':emoji' },
  { label: 'Frontend', path: 'frontend', tab: ':frontend' },
  { label: 'Gopher', path: 'gopher', tab: ':gopher' },
  { label: 'HTTP', path: 'http', tab: ':http' },
  { label: 'Instance', path: 'instance', tab: ':instance' },
  { label: 'Job queue', path: 'job-queue', tab: ':job_queue' },
  { label: 'Link Formatter', path: 'link-formatter', tab: ':link_formatter' },
  { label: 'Mailer', path: 'mailer', tab: ':mailer' },
  { label: 'Media Proxy', path: 'media-proxy', tab: ':media_proxy' },
  { label: 'Metadata', path: 'metadata', tab: ':metadata' },
  { label: 'MRF', path: 'mrf', tab: ':mrf' },
  { label: 'Rate limiters', path: 'rate-limiters', tab: ':rate_limiters' },
  { label: 'Web push encryption', path: 'web-push', tab: ':web_push' },
  { label: 'Upload', path: 'upload', tab: ':upload' },
  { label: 'Other', path: 'other', tab: ':other' }
]
